import TrendingSummaryPanel from "./trendingSummaryPanel.container";

export default TrendingSummaryPanel;
